const resetMyPassword = {
  title: 'italist | Reset my password',
};

export default resetMyPassword;
